import { Sheet, SheetContent } from "components/ui/sheet";
import {
  BundleDrawerBody,
  type BundleDrawerBodyProps,
} from "./BundleDrawerBody";

interface BundleDrawerProps extends Omit<BundleDrawerBodyProps, "onClose"> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Format-selection drawer. Opens as a draft (nothing applied until confirm);
 * the current format is always included and locked. Presentational: it owns no
 * data or bundle state, both are supplied by the caller. The sheet content
 * unmounts on close, so the draft selection resets each time it reopens.
 */
export const BundleDrawer = ({
  open,
  onOpenChange,
  ...bodyProps
}: BundleDrawerProps) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent
      side="right"
      className="flex flex-col gap-0 p-0 sm:max-w-md"
      data-testid="bundle-drawer"
    >
      <BundleDrawerBody {...bodyProps} onClose={() => onOpenChange(false)} />
    </SheetContent>
  </Sheet>
);
